import { useEditItem2 } from "../../api/useNewItem";
import { useUserSettings, useUserSettingsData } from "./UserSettingsContext";

interface Config {
  mode?: "global" | "user";
  apiPath?: string;
}

export const useUserSettingsBlockEditor = (settingsField: string, cfg?: Config) => {
  const { mode, apiPath } = cfg || {};
  const settingsCtx = useUserSettings();
  const settingsLoaded = useUserSettingsData(apiPath || "", { autoLoad: !!apiPath });
  const settings = apiPath ? settingsLoaded : settingsCtx;

  const settingsData = mode === "user" ? settings.user : settings.global;
  const field = settingsData[settingsField] || {};

  const data = useEditItem2({
    save: item => {
      const update = mode === "user" ? settings.updateUser : settings.updateGlobal
      return update({ [settingsField]: item }).then(x => x[settingsField])
    },
  });

  return {
    ...data,
    isLoading: (mode === "user" ? settings.isLoadingUser : settings.isLoadingGlobal) || data.isLoading,
    start: () => data.startEditing(field),
  }
}
